export default __webpack_public_path__ + "static/media/arrow-back.782f45c7.svg";